var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import PipelineDomainService from "../Domain/Pipeline/Pipeline.service";
import OpportunityDomainService from "../Domain/Opportunity/Opportunity.service";
const BASE_URL = "/aviso/pipeline";
export default class PipelineService {
    static get(pipelineId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/get", {
                id: pipelineId,
            }).then(PipelineDomainService.fromJSON);
        });
    }
    static create(pipelineCreateRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/create", pipelineCreateRequest).then(PipelineDomainService.fromJSON);
        });
    }
    static edit(pipelineEditRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            // @ts-expect-error - TS2322 - Type 'PipelineLite | Pipeline' is not assignable to type 'PipelineLite'.
            return FetchService.postSingleResponse(BASE_URL + "/edit", pipelineEditRequest).then(PipelineDomainService.fromJSON);
        });
    }
    static search(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const resp = yield FetchService.getPagedResponse(BASE_URL + "/search", {
                createdDateFrom: search.createdDateFrom,
                createdDateTo: search.createdDateTo,
                modifiedDateFrom: search.modifiedDateFrom,
                modifiedDateTo: search.modifiedDateTo,
                maxOpportunityStageUpdatedDateFrom: search.maxOpportunityStageUpdatedDateFrom,
                maxOpportunityStageUpdatedDateTo: search.maxOpportunityStageUpdatedDateTo,
                searchText: search.searchText,
                orderBy: search.orderBy,
                pipelineIds: search.pipelineIds,
                canViewRoleIds: search.canViewRoleIds,
                canManageOpportunitiesRoleIds: search.canManageOpportunitiesRoleIds,
                fullAccessRoleIds: search.fullAccessRoleIds,
                virtualizedAppName: search.virtualizedAppName,
                personTypeIds: search.personTypeIds,
                personTypeName: search.personTypeName,
                pipelineStatusIds: search.pipelineStatusIds,
                ignorePermissions: search.ignorePermissions,
                excludingPipelineIds: search.excludingPipelineIds,
                query: search.query,
                max: options === null || options === void 0 ? void 0 : options.max,
                offset: options === null || options === void 0 ? void 0 : options.offset,
                sort: options === null || options === void 0 ? void 0 : options.sort,
                order: options === null || options === void 0 ? void 0 : options.order,
            });
            return Object.assign(Object.assign({}, resp), { 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                data: resp.data.map(PipelineDomainService.liteFromJSON) });
        });
    }
    static activatePipeline(pipelineId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/setActive", {
                pipelineId,
            }).then(PipelineDomainService.fromJSON);
        });
    }
    static archive(pipelineId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/archive", {
                pipelineId,
            }).then(PipelineDomainService.fromJSON);
        });
    }
    static enrollPerson(request) {
        return FetchService.postSingleResponse(BASE_URL + "/enrollPerson", Object.assign(Object.assign({}, request), { pipelineId: request.stageId ? null : request.pipelineId })).then(OpportunityDomainService.fromJSON);
    }
    static enrollPopulation(request) {
        return FetchService.postSingleResponse(BASE_URL + "/enrollPopulation", {
            populationId: request.populationId,
            // TODO why do we do this?  This doesn't make any sense.
            pipelineId: request.stageId ? null : request.pipelineId,
            entryDate: request.entryDate,
            opportunitySourceId: request.opportunitySourceId,
            stageId: request.stageId,
            assignedToPersonId: request.assignedToPersonId,
        });
    }
    static refreshPipelinePopulation(pipelineId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/refreshPipelinePopulation", {
                pipelineId,
            }).then(PipelineDomainService.fromJSON);
        });
    }
    static getOpportunityCount(pipelineId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/getOpportunityCount", {
                pipelineId,
            });
        });
    }
    /*
     * Checks if the current user can edit opportunities for the passed pipeline id
     */
    static canCurrentUserEditOpportunities(pipelineId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/canCurrentUserEditOpportunities", { pipelineId });
        });
    }
    static canCurrentUserViewPipeline(pipelineId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/canCurrentUserViewPipeline", { pipelineId });
        });
    }
    static getLastOpportunityStageMoveDate(pipelineId) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.getSingleResponse(BASE_URL + "/getLastOpportunityStageMoveDate", { pipelineId }).then((date) => new Date(date));
        });
    }
    static createPipelineWithStagesAndSchedule(form) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/createPipelineWithStagesAndSchedule", Object.assign({}, form));
        });
    }
    static editPipelineWithStagesAndSchedule(form) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(BASE_URL + "/editPipelineWithStagesAndSchedule", Object.assign({}, form));
        });
    }
    static updateStageOrder(pipelineId, newStageOrder) {
        return FetchService.postSingleResponse(BASE_URL + "/updateStageOrder", {
            pipelineId,
            newStageOrder,
        });
    }
    static getApplicableAssignees(search, options = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield FetchService.getPagedResponse(BASE_URL + "/getApplicableAssignees", {
                pipelineId: search.pipelineId,
                query: search.query,
                sort: search.sort,
                order: search.order,
                options: {
                    max: options.max,
                    offset: options.offset,
                    sort: options.sort,
                    order: options.order,
                },
            });
            return Object.assign(Object.assign({}, response), { 
                // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                data: response.data.map(PipelineDomainService.liteFromJSON) });
        });
    }
}
